import React, { useContext, useState, useEffect } from 'react'
import InformationPersonnellesProfile from './informationPersonnellesProfile'
import UserContext from 'contexts/UserContext'
import IconUpdateProfile from '../../assets/iconUpdateProfile.svg'
import UpdateInfo from './updateInfo'
import iconModalUpdateUser from '../../assets/iconModalUpdateUser.svg'
import classNames from 'classnames'
import { updateProfilUser } from 'requests/user'
import localforage from 'localforage'
import { toast } from 'react-toastify'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ModalLogOutContainer from 'containers/logOutContainer/modalLogOutContainer'

type infoPersonnel=
{
  firstName: string,
  lastName: string,
  // selectedOption: string,
  // dateNaissance: string

}
type FormValues = {
  phoneNumber: string
  email: string
  street: string
  zipCode: string
  city: string
  pays: string
  firstName: string
  lastName: string
  dateNaissance: string
  selectedOption: string
}



const UpdateMonProfile = () => {


const { user, setUser } = useContext(UserContext)
const [isSauvgarde, setIsSauvgarde] = useState(false)
const [isUpdating, setIsUpdating] = useState(false)
const [isUpdatAdress, setIsUpdateAdress] = useState(false)
const [isUpdatContact, setIsUpdateContact] = useState(false)
const [isUpdatInfoPersonnel , setIsUpdatInfoPersonnel ]= useState(false)

const [errorValue, setErrorValue] = useState(false)
const [isKyc, setIsKyc] = useState(false)
const [ConfirmedUpdateKyc, setConfirmedUpdateKyc] = useState(false)
const [infoPersonnel, setInfoPersonnel]= useState<infoPersonnel |  null>()
const [openModal, setOpenModal]= useState(false)
const [errorValuePersonnelInfo, setErrorValuePersonnelInfo]= useState(false)

const[messageErreur, setMessageErreur]= useState('')

const isValidInfoPersonnel = (user?.user.status === 'confirmed' ? true : false)


const validationSchema = Yup.object({
  street: Yup
   .string()
   .required('Ce champ est requis')
   .min(5, 'Veuillez renseigner votre adresse.')
   .test('no-empty', 'Ce champ est requis.', (value) => value?.trim() !== ''),

  city: Yup
   .string()
   .required('Ce champ est requis')
   .matches(/^[a-zA-ZÀ-ÿ\s'-]+$/, 'Le nom de la ville ne doit contenir que des lettres et des espaces.')
   .min(4, 'Veuillez renseigner votre ville.')
   .test('no-empty', 'Ce champ est requis.', (value) => value?.trim() !== ''),

  zipCode: Yup
   .string()
   .required('Ce champ est requis')
   .matches(/^[a-zA-Z0-9]/,'Le code postal est obligatoire' )
   .min(4, 'Veuillez renseigner votre code postal.')
   .test('no-empty', 'Ce champ est requis.', (value) => value?.trim() !== ''),

  email: Yup
    .string()
    .email('Adresse email invalide')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Adresse email invalide')
    .required('Ce champ est requis'),

  phoneNumber: Yup.string()
     .min(6, 'Veuillez entrer un numéro de téléphone valide selon votre pays de résidence')
      .matches(/^\d+$/, 'Le numéro doit contenir uniquement des chiffres')
      .required('Ce champ est requis'),
  
})

const closeModal = ()=>{
      setOpenModal(false)
      setIsUpdating(false)
      setIsKyc(false)
      setErrorValue(false)
      setIsSauvgarde(false)
      setIsUpdatInfoPersonnel(false)
  }


const handleConfirmUpdate = async()=>{   
      
        setOpenModal(false)
        setIsKyc(false)
        await handleUpdate(formik.values)
        setConfirmedUpdateKyc(false)
      //////
      
}

// const closeModal =async () =>{
//   if(!ConfirmedUpdateKyc)
//   {
//   setOpenModal(false)
//   setIsUpdating(false)
//   setIsKyc(false)
//   setErrorValue(false)
//   setIsSauvgarde(false)
//   setIsUpdatInfoPersonnel(false)
//     console.log('infoPersonnel retour',infoPersonnel)

// }
//   else{
//     console.log('infoPersonnelkyc',infoPersonnel)
//     console.log('update KYC')
//     setOpenModal(false)
//     await formik.submitForm()
//   }
// }
const formik = useFormik<FormValues>({
 initialValues: {
  phoneNumber: user?.user?.personalInfo.phone.number || '',
  email: user?.user?.email || '',
  street: user?.user?.address?.street || '',
  zipCode: user?.user?.address?.zipCode || '',
  city: user?.user?.address?.city || '',
  pays: user?.user?.address?.country?.name || '',
  firstName: user?.user?.personalInfo?.firstName || '',
  lastName: user?.user?.personalInfo?.lastName  || '',
  dateNaissance: user?.user.birthDate || '',
  selectedOption : user?.user.personalInfo.gender || ''
  
 },
 

 validationSchema,
//  onSubmit: async (values) => {
  
//     setIsUpdating(true)
//     setIsSauvgarde(true)
//     setMessageErreur('')
   
//      if (isKyc) {
//         setOpenModal(true)
//         return
//       }
     
//       try{
//      const response = await updateProfilUser(
//         user?.user._id,
//         formik.values.phoneNumber,
//         formik.values.email,
//         formik.values.street,
//         formik.values.zipCode,
//         formik.values.city,
//         infoPersonnel?.firstName,
//         infoPersonnel?.lastName,
//         infoPersonnel?.selectedOption,
//         infoPersonnel?.dateNaissance,
//         user?.token?.accessToken
//       )
//       console.log('tttresp', response ,
//         formik.values.phoneNumber,
//         formik.values.email,
//         formik.values.street,
//         formik.values.zipCode,
//         formik.values.city,
//         infoPersonnel?.firstName,
//         infoPersonnel?.firstName,
//         infoPersonnel?.selectedOption,
//         infoPersonnel?.dateNaissance,
//       )
//       if (response?.success && user) {
        
 
//         setUser({ token: user.token, success: true, user: response.user })
//         localforage.setItem('auth', JSON.stringify({ token: user?.token, success: true, user: response.user }))
//         setIsUpdateAdress(false)
//         setIsUpdateContact(false)
//         setIsUpdatInfoPersonnel(false)
//         setConfirmedUpdateKyc(false)
//         toast.info(`Mise à jour effectuée`,{
//         position: 'top-right',
//         autoClose: 3000
        
//       })
//       setTimeout(()=>{
//         setIsSauvgarde(false)
//       },3000)

//       formik.resetForm({ values })
//     }else{
   
//       setMessageErreur('Un autre compte utilise déjà ce numéro de téléphone ou cette adresse e-mail.')
//     }
//  }catch (error){
//   setMessageErreur('Une erreur est survenue.')
//  }finally {
//   setIsUpdating(false)
// }}


onSubmit: async (values) => {
  setIsUpdating(true)
  setIsSauvgarde(true)
  setMessageErreur('')

  if (isKyc) {
    setOpenModal(true)
    return
  }

  await handleUpdate(values)
}

 
})




const handleUpdate = async (values: FormValues) => {
  try {
    const response = await updateProfilUser(
      user?.user._id,
      user?.token?.accessToken,
      values.phoneNumber,
      values.email,
      values.street,
      values.city,
      values.zipCode,
      infoPersonnel?.lastName,
      infoPersonnel?.firstName,
    )

    if (response?.success && user) {
      setUser({ token: user.token, success: true, user: response.user })
      await localforage.setItem('auth', JSON.stringify({ token: user?.token, success: true, user: response.user }))
      formik.resetForm({ values })
      toast.info('Mise à jour effectuée')
      setIsUpdateAdress(false)
      setIsUpdateContact(false)
      setIsUpdatInfoPersonnel(false)
      setConfirmedUpdateKyc(false)
    } else {
      setMessageErreur('Un autre compte utilise déjà ce numéro de téléphone ou cette adresse e-mail.')
    }
  } catch (error) {
    setMessageErreur('Une erreur est survenue.')
  } finally {
    setIsUpdating(false)
    setIsSauvgarde(false)
  }
}


// useEffect(() => {
//   setMessageErreur('')
//   setIsSauvgarde(false)

// }, [formik.values.phoneNumber, formik.values.email])

const HandleFieldFocus = ()=>{
  setIsSauvgarde(false)
  setMessageErreur('')

}
useEffect(() => {
  const hasError = Object.keys(formik.errors).length > 0
   setErrorValue(hasError)
 
   setIsSauvgarde(false)
  }, [formik.errors, formik.dirty])
  return (
    <div className='px-[5%] sm:px-0 my-10'> 
          <div className="flex w-full gap-[10%] lg:gap-2 lg:flex-col ">

            <div className='w-1/2 lg:w-full'>

                
              
              <InformationPersonnellesProfile 
              setInfoPersonnel={setInfoPersonnel}
              isUpdatInfoPersonnel={isUpdatInfoPersonnel}  setIsUpdatInfoPersonnel ={setIsUpdatInfoPersonnel}
              isValidInfoPersonnel={isValidInfoPersonnel} HandleFieldFocus={HandleFieldFocus} 
              setErrorValuePersonnelInfo={setErrorValuePersonnelInfo}
              setIsKyc={setIsKyc}
              />
            </div>

            
            <div className='flex lg:w-full flex-col w-1/2'>

              <div>         
                <div className='flex justify-between mb-[24px] items-center'>
                  <h3 className="h3  ">
                    Informations de contact
                  </h3>
                  { isValidInfoPersonnel ?

                    (!isUpdatContact ?
                      <img className='cursor-pointer' 
                      onClick={ ()=> { setIsUpdateContact(true) }} 
                      src={IconUpdateProfile} 
                      alt='setting info contact'
                    /> : 
                    <div onClick={ ()=> {setIsUpdateContact(false); formik.resetForm({
                      values:{
                        ...formik.values,
                        phoneNumber: user?.user?.personalInfo.phone.number || '',
                        email: user?.user?.email || '',
                      }
                    })}} className='text-[#5754E5]  font-semibold cursor-pointer  hover:text-[#4D36CC] '>Annuler</div>
                  )
                  : (<div></div>)

                  }

                </div>      
                <form className=' border rounded-lg p-4 '>

                    <UpdateInfo  onFocus={HandleFieldFocus}  formik={formik} infoValue1={user?.user.personalInfo.phone.prefix} infoValue2={formik.values.phoneNumber} title='Numéro de téléphone' isUpdate={isUpdatContact}  fieldName="phoneNumber" widthInput='w-[220px] lg:w-[170px]'  />
                    <UpdateInfo onFocus={HandleFieldFocus}  formik={formik} infoValue2={formik.values.email}  title='Adresse e-mail' isUpdate={isUpdatContact}  fieldName="email"   widthInput='w-[240px] lg:w-[210px]'/>
            
                </form>
              </div>

              <div>
                <div className='flex justify-between items-center'>
                  <h3 className="h3 my-[24px] ">
                  Mon adresse
                  </h3>
                  { isValidInfoPersonnel ?
                  (!isUpdatAdress ?
                    <img className='cursor-pointer' 
                      onClick={ ()=> { setIsUpdateAdress(true) }} 
                      src={IconUpdateProfile} 
                      alt='setting info Adress'
                    />
                    :
                    <div onClick={ ()=> {setIsUpdateAdress(false); formik.resetForm({
                      values:{
                        ...formik.values,
                        street: user?.user?.address?.street || '',
                        zipCode: user?.user?.address?.zipCode || '',
                        city: user?.user?.address?.city || '',
                        pays: user?.user?.address?.country?.name || ''
                        
                      }
                    })}} className='text-[#5754E5]  font-semibold cursor-pointer  hover:text-[#4D36CC] '>Annuler</div>
                  )
                  :(<div></div>)
                  }
                </div>
                <div className=' border rounded-lg p-4'>
                  <UpdateInfo onFocus={HandleFieldFocus}  formik={formik}  infoValue2={formik.values.street}  title='Adresse de résidence' isUpdate={isUpdatAdress}  fieldName="street"  />
                  <UpdateInfo onFocus={HandleFieldFocus}  formik={formik} infoValue2={formik.values.zipCode}   title='Code postal' isUpdate={isUpdatAdress}  fieldName="zipCode" />
                  <UpdateInfo onFocus={HandleFieldFocus}  formik={formik} infoValue2={formik.values.city}   title='Ville' isUpdate={isUpdatAdress}  fieldName="city" />
                  <UpdateInfo onFocus={HandleFieldFocus}  formik={formik} infoValue2={formik.values.pays}  title='Pays' isUpdate={false}  fieldName="pays" />
                </div>
              </div >

            </div>
          </div>
         { isValidInfoPersonnel &&
         <div className='flex flex-col items-center gap-3 my-8'>
           <span className='text-red-500'> {messageErreur} </span>
            <button type="submit" 
              onClick={formik.submitForm}
              className={classNames(' text-white  px-4 rounded-lg w-[500px] font-bold h-[56px] lg:w-full',
                (!isKyc && !formik.dirty || errorValue || errorValuePersonnelInfo ) ? ' bg-[#D1D1FF] cursor-not-allowed' : 'bg-[#4743C9]'
              )}
            >
              

            { isSauvgarde ? 
            <div className='flex flex-col'>
              <svg
                className="w-6 h-6 mx-auto animate-spin text-white "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-50"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                ></path>
              </svg>
              <span> Sauvegarde en cours...</span>            
            </div>
            : 'Enregistrer'}
             
            </button>
          </div>
          }

          {openModal && 
          <ModalLogOutContainer
          isOpen={openModal}
          closeModal={closeModal}
          openModalLogOut={openModal}
          nomModal='Avant de valider !'
          confirmationText="Êtes-vous sûr de vouloir continuer ?"
          description='Si vous enregistrez ces modifications, vous devrez de nouveau vérifier votre identité.'
          UpdateKYC={setConfirmedUpdateKyc}
          logOutImage={iconModalUpdateUser}
          handleConfirmUpdate={handleConfirmUpdate}
          />
          }

    </div>
  )
}

export default UpdateMonProfile
